import React, { useEffect, useState } from "react";
import { RxDashboard } from "react-icons/rx";
import { CgProfile } from "react-icons/cg";
import { HiOutlineUsers } from "react-icons/hi";
import { RiBookMarkFill } from "react-icons/ri";
import { AiFillSetting } from "react-icons/ai";
import { NavLink } from "react-router-dom";
import {
  COURS_PROF_NAVIGATION,
  ETUDIANTS_PROF_NAVIGATION,
  PROFIL_NAVIGATION,
  PARAMETRE_NAVIGATION,
} from "../../../Routes/NAVIGATION_PATH";
import logo from "../../../Assets/logo.svg";

function SideBar() {
  return (
    <>
      <div id="" className=" container-fluid side-bar">
        <div className="col-auto side-menu">
          
          <NavLink to = '' className="nav-link side-link ps-2 ">
            <RxDashboard className="side-rx" />
            <span className="ms-1 d-none d-md-inline fs-6 side-span">
              Dashboard
            </span>
          </NavLink>

          <NavLink to = {ETUDIANTS_PROF_NAVIGATION} className="sub-btn nav-link ps-2 side-link">
            <HiOutlineUsers className="side-hi" />
            <span className="ms-1 d-none d-md-inline fs-6 side-span">
              Etudiants
            </span>
          </NavLink>

          <NavLink to = {PROFIL_NAVIGATION} className="nav-link ps-2 side-link">
            <CgProfile className="side-cg" />
            <span className="ms-1 d-none d-md-inline fs-6 side-span">
              Profil
            </span>
          </NavLink>

          <NavLink to = {PARAMETRE_NAVIGATION} className="sub-btn nav-link ps-2 side-link">
            <AiFillSetting className="side-hi" />
            <span className="ms-1 d-none d-md-inline fs-6 side-span">
              Paramètre
            </span>
          </NavLink>
        </div>
      </div>
    </>
  );
}

export default SideBar;
